@file:Suppress("unused")

package net.sergeych.ugdx

import kotlinx.datetime.Instant

/**
 * Reasons to request for password in app-modal mode
 */
enum class PasswordRequestReason(val text: String) {
    EXPORT_OPERATION("approve export operaation"),
    TRANSFER_FUNDS("approve funds transfer"),
    STOCK_OPERATION("approve stock echange operation"),
    UNLOCK("restore access after an inactivity")
}

/**
 * Error while checking the supplied password
 */
data class PasswordErrorResult(
    /**
     * Text to (optionally) display to user
     */
    val message: String,
    /**
     * If not null, then next password attempt could be only after the specified instant.
     */
    val nextAttemptAt: Instant?
)

/**
 * Current state of the API (and therefore ugdx application) is represented by members of this class. The varying
 * state is represented by a `StateFlow` by [GuestAPI().stateFlow]: collect it or check its current value.
 */
sealed class ServiceState {

    /**
     * The system is not yet initialized, is being loading. UI should show some king od loading splash screen
     * or like.
     */
    data object Loading : ServiceState()
    /**
     * Service know no signed-in user. This is a state after [UserAccount.signOut] or when an application is
     * accessed for the first time. Guest (visitor) UI should be presented.
     */
    data object NotSignedIn : ServiceState()

    /**
     * User is successfully signed in into a service (also offline, or when state is remembered). Personalized
     * UI should be shown using data provided by [UserAccount] param
     *
     * @param userAccount account of the current active user. UI app should __always__ use most recent instance from
     *                            there, updating local copy (say. with remembered [MutableStateOf<UserAccount>])
     */
    data class SignedIn(val userAccount: UserAccount) : ServiceState()

    /**
     * App-modal password request. The regular UI should be hidden (better by not building it in the DOM tree) and
     * the modal request for password should be shown with "OK" and "Cancel" buttons that call [tryPassword] and
     * [cancel] respectively. The API then changes application state accordingly.
     */
    abstract class PasswordRequest : ServiceState() {
        /**
         * User has entered the password, process it with requesting API process. The system will change [ServiceState]
         * as needed automatically, so no need to process successful result
         *
         * @return null if the password is OK and no more action is required. Otherwise, error result to organize the
         *              retry
         */
        abstract suspend fun tryPassword(password: String): PasswordErrorResult?

        /**
         * Call it when user has choosen to cancel the operation. The system will change [ServiceState]
         * as needed automatically, so no need to process successful result
         */
        abstract fun cancel()
    }
}